export const regulamento = `REGULAMENTO COLÔNIA DE FÉRIAS 2026

1. DECLARAÇÃO DO RESPONSÁVEL PELA CRIANÇA
O responsável pela inscrição da(s) criança(s) na Colônia de Férias 2026 do CLUBE UBA e nos serviços opcionais declara:
1.1 – Ter fornecido todas as informações necessárias para zelar pelo bem-estar e segurança da criança;
1.2 – Ter lido e concordar com todos os termos deste regulamento;
1.3 – Ter a guarda legal do(s) menor(es) inscrito(s) ou estar formalmente autorizado pelo responsável legal;
1.4 – Estar ciente de que o Clube UBA não se responsabiliza por consequências da omissão de informações ou do não cumprimento deste regulamento;
1.5 – Ter fornecido apenas informações verdadeiras.

2. INSCRIÇÕES
2.1 – A Colônia de Férias 2026 será realizada de *, das *13h às 17h30.
- Dia 23 (quinta): atividades até às 17h, retorno às 19h para atividades noturnas e acampadentro.
- Dia 23 (sexta): atividades das 8h às 11h.
2.2 – Inscrições pelo sistema do clube, sujeitas à disponibilidade de vagas, de 13 a 18 de julho, até às 17h do dia útil anterior ao início.
2.3 – Tolerância de 15 minutos para deixar e buscar a criança.
2.4 – Idade: de 4 a 14 anos, e que não usem mais fraldas.
2.5 – Crianças com necessidades especiais devem vir acompanhadas de um responsável.
2.6 – As turmas serão divididas por faixa etária. A organização pode ajustar a turma se a criança não acompanhar o ritmo da idade superior.
2.7 – Responsáveis declaram ciência dos riscos de atividades físicas e isentam o Clube UBA de responsabilidade por danos decorrentes de fatos inevitáveis.
2.8 – Ao inscrever, o responsável declara que médico atestou, nos últimos 6 meses, que a criança está apta para atividades físicas.
2.9 - Taxa de inscrição: R$ 220,00 (associados) e R$ 300,00 (não associados). Inclui: crachá, camisa e pulseira de identificação.
- 2ª via de crachá ou pulseira: R$ 10,00
- Camisa extra: R$ 60,00
- Bingo e fotos não estão incluídos.

3. FUNCIONAMENTO DA COLÔNIA DE FÉRIAS
3.1 – Entrega e retirada com o professor da turma, no salão de eventos, com uniforme, crachá e pulseira.
3.2 – Não associados não podem permanecer no clube durante a colônia, por segurança e para garantir a socialização.
3.3 – Responsáveis associados não devem ficar junto às turmas para não atrapalhar a integração e as atividades.
3.4 – A criança só será entregue a responsáveis autorizados na inscrição, mediante apresentação de documento. Saída antes do horário deve ser solicitada à coordenação.
3.5 – Crianças não autorizadas na piscina não devem levar roupa de banho. Não haverá atividade alternativa nesse horário.
3.6 – Em dias de chuva, a colônia funciona normalmente com atividades em áreas cobertas.
3.7 – Não será fornecido lanche. Os responsáveis podem enviar lanche de casa. Alimentos que precisem de refrigeração devem ser entregues no início do dia. Não há forno ou micro-ondas.
3.8 – Não será permitido comprar alimentos nas cantinas, restaurantes e bares do clube.
3.9 – Conduta esperada:
- Respeitar professores, monitores e equipe;
- Tratar todos com cordialidade, sem discriminação;
- Ser pontual e participar das atividades;
- Cuidar do espaço e dos materiais coletivos.
3.9.1 – Danos materiais causados pela criança devem ser ressarcidos pelo responsável.
3.10.1 – Em caso de indisciplina, a criança receberá advertência ao responsável. Em caso de reincidência ou falta grave, poderá ser desligada.

4. HORÁRIO DE FUNCIONAMENTO
SEGUNDA / TERÇA / QUARTA: 13h às 17h30
QUINTA: 12h30 às 17h + 19h às 21h30 (todas as crianças)
ACAMPADENTRO: das 21h30 de quinta até 11h de sexta (crianças acima de 6 anos)
SEXTA: 8h às 11h

5. ADAPTAÇÃO DA CRIANÇA À COLÔNIA DE FÉRIAS
5.1 – A equipe é treinada para acolher com carinho. Um pouco de choro no início é normal, como na adaptação escolar.
5.2 – Crianças até 4 anos podem ser acompanhadas no 1º dia por um responsável.
5.3 – O acompanhante não deve ficar junto à turma. Se necessário, a equipe chamará para acalmar a criança.
5.4 – Acompanhante não associado receberá pulseira de identificação e não poderá usar as instalações do clube durante a adaptação.

6. ATIVIDADES DA COLÔNIA DE FÉRIAS
6.1 – Atividades planejadas por profissionais de Educação Física, adequadas a cada faixa etária: brinquedos, teatro, contação de histórias, culinária, gincanas, festas temáticas, caça ao tesouro, caminhada ecológica, esportes, brincadeiras na piscina, parquinho, artes plásticas, etc.
6.2 – A programação diária será divulgada pelo app ou grupo de WhatsApp, apenas para informação.

7. CUIDADOS ESPECIAIS
7.1 – Medicamentos só serão administrados com autorização expressa do responsável.
7.2 – Alergias e cuidados especiais devem ser informados na inscrição. O clube não se responsabiliza por omissões.
7.3 – Em caso de acidente, serão prestados primeiros socorros na enfermaria e o responsável será avisado. Em urgência, o clube está autorizado a encaminhar a criança ao hospital mais próximo.
7.4 – Durante o evento haverá enfermeiro todos os dias e salva-vidas nos dias de piscina.

8. TRAJES E ACESSÓRIOS
8.1 – Uso obrigatório da camisa, pulseira e crachá da Colônia de Férias.
8.2 – Todos os pertences devem estar identificados com nome, sobrenome e idade.
8.3 – Trazer diariamente: muda de roupa, toalha, protetor solar, repelente, pente/escova, estojo para aparelho/óculos se usar, saco plástico para roupa molhada, maiô ou sunga já vestidos por baixo da roupa.
8.4 – Evitar joias. Usar tênis para maior proteção.
8.5 – É proibido levar celular, tablet, MP3/MP4, câmera, jogos ou eletrônicos. O clube não se responsabiliza por esses itens.
8.6 – Para falar com a criança, ligar para a organização.
8.7 – O clube não se responsabiliza por perda ou dano de objetos pessoais.
8.8 – Objetos perdidos e não identificados serão guardados. Ao final, os não retirados serão doados a instituições de caridade.

9. VALORES
Não haverá devolução de valores pagos por inscrição, bingo, vídeo, foto ou topic.
Associado inadimplente deverá pagar como não associado ou quitar o débito.
Alunos das escolinhas de futsal e natação em dia, mesmo não associados, pagam como associados.

10. LANCHE
Este ano não será oferecido lanche. Cada criança deve levar o seu.
Será servida sobremesa todos os dias: picolé, sorvete ou açaí. A sobremesa do dia será informada.
Proibido enviar: pirulitos, balas e chicletes.

11. DIREITOS DE IMAGEM, SOM E INFORMAÇÕES
11.1 – O Clube UBA pode usar fotos, vídeos, entrevistas e depoimentos das crianças para divulgação, sem remuneração.
11.2 – Mídias e patrocinadores não podem veicular imagens das crianças sem autorização.

12. CONTATOS
Orientações e informações sobre a criança devem ser feitas durante a realização da Colônia de Férias diretamente com a coordenação.`;
